import { z } from 'zod'

export const initializeGlobalErrorMessages = () => {
  z.config({
    customError: (iss) => {
      if (iss.code === 'invalid_type') {
        if (iss.expected === 'int') {
          return 'Bitte geben Sie eine ganze Zahl ein (keine Dezimalstellen)'
        }
        return `Pflichtfeld darf nicht leer sein`
      }
      if (iss.code === 'too_small') {
        return `Eingabe muss größer als ${iss.minimum} sein`
      }
      if (iss.code === 'too_big') {
        return `Eingabe muss kleiner als ${iss.maximum} sein`
      }
      if (iss.code === 'invalid_format') {
        if (iss.format === 'email') {
          return 'Ungültige E-Mail-Adresse'
        }
      }
      if (iss.code === 'invalid_value') {
        return `Auswahl erforderlich`
      }
      return undefined
    },
  })
}
